import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GuestSiteUnlockStateQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GuestSiteUnlockStateQuery = {
  __typename?: 'Query';
  eventByName?: { __typename?: 'Event'; id: string; activeSession: { __typename?: 'EventSession'; id: string; hasUnlocked: boolean; canPreviewDraft: boolean } } | null;
};

export const GuestSiteUnlockStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestSiteUnlockState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasUnlocked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canPreviewDraft' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGuestSiteUnlockStateQuery__
 *
 * To run a query within a React component, call `useGuestSiteUnlockStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestSiteUnlockStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestSiteUnlockStateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGuestSiteUnlockStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestSiteUnlockStateQuery, GuestSiteUnlockStateQueryVariables>) {
  return ApolloReactHooks.useQuery<GuestSiteUnlockStateQuery, GuestSiteUnlockStateQueryVariables>(GuestSiteUnlockStateDocument, baseOptions);
}
export function useGuestSiteUnlockStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestSiteUnlockStateQuery, GuestSiteUnlockStateQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GuestSiteUnlockStateQuery, GuestSiteUnlockStateQueryVariables>(GuestSiteUnlockStateDocument, baseOptions);
}
export type GuestSiteUnlockStateQueryHookResult = ReturnType<typeof useGuestSiteUnlockStateQuery>;
export type GuestSiteUnlockStateLazyQueryHookResult = ReturnType<typeof useGuestSiteUnlockStateLazyQuery>;
export type GuestSiteUnlockStateQueryResult = Apollo.QueryResult<GuestSiteUnlockStateQuery, GuestSiteUnlockStateQueryVariables>;
